import React from 'react';
import { useIntl } from 'react-intl';
import { SearchBarContainerWithProviders } from '@eventbrite/consumer-search.search-bar';
import classNames from 'classnames';
import { GlobalNavProvider } from '../../state';
import { GlobalNavProps } from '../../types';

import styles from './ConsumerHeaderSearchBar.module.scss';

export const ConsumerHeaderSearchBar: React.FC<GlobalNavProps> = ({ searchBar, user, env }) => {
    const { formatMessage } = useIntl();
    const searchBarClassnames = classNames(
        styles.consumerHeaderSearchBar,
        styles.withSearchDropdown,
    );
    return (
        <GlobalNavProvider
            positionSticky={{ desktop: false, mobile: false }}
            searchBar={searchBar}
            user={user}
            env={env}
        >
            <div className={searchBarClassnames}>
                <nav
                    aria-label={formatMessage({
                        id: 'Main Navigation',
                        defaultMessage: 'Main Navigation',
                    })}
                    data-testid="consumer-header-nav"
                >
                    <SearchBarContainerWithProviders
                        usesLanguageSubdirectory={
                            env?.localeInfo?.uses_language_subdirectory || false
                        }
                        locale={env?.localeInfo?.locale}
                        user={user}
                        location={searchBar?.location}
                        initialQuery={searchBar?.searchQuery}
                        chatbotEnabled={searchBar?.chatbotEnabled}
                        completionTypes={searchBar?.completionTypes}
                        onAutocompleteCallback={searchBar?.onAutocompleteCallback}
                        pageType={searchBar?.pageType}
                    />
                </nav>
            </div>
        </GlobalNavProvider>
    );
};
